<template>
  <!-----------------MAIN CONTAINER----------------------------------------------->
  <v-container>
    <v-alert color="#BBDEFB"
      >English is the default language (it's not listed in the table)</v-alert
    >
    <!-----------------SEARCH BAR------------------------------------------------->
    <v-card-title v-if="!failed">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
    </v-card-title>
    <!---------------------------------------------------------------------------->

    <!----------------------EDIT, ADD NEW BRAND FORM------------------------------->

    <!---------BRANDS DATA TABLE------------------------------------------------->

    <v-data-table
      :headers="headers"
      :items="finalBrands"
      :search="search"
      class="elevation-1"
      v-if="!failed"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Languages</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="success" outlined @click="addNewBrand" class="mx-2"
            ><v-icon> mdi-plus-circle-outline </v-icon> Add a Language</v-btn
          >

          <!---------DIALOG DELETE BRAND------------------------------------------------->
          <v-dialog v-model="dialogDelete" width="unset">
            <v-card>
              <v-card-title class="headline"
                >Are you sure you want to delete Language
                {{ selecetdBrand }}?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" outlined @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="success" outlined @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!----------------------------------------------------------------------------->
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="translation-action">
          <v-icon small class="mr-2" @click="editBrand(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          <v-btn class="translate-btn" @click="translateMissing(item)">
            Translate settings
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <!---------------------------------------------------------------------------->

    <!---------------------------------------------------------------------------->

    <!---------------------------------------------------------------------------->

    <!----------------------RED SNACKBAR------------------------------------------>
    <v-snackbar
      top
      v-model="snackbar"
      color="#FF3232"
      class="white--text"
      width="800"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!---------------------------------------------------------------------------->

    <!------STATUS COMPONENT IF SERVER IS COMPLETELY DOWN-------------------------->
    <status-info
      v-if="failed && filename !== ''"
      :responseMessage="responseMessage"
      :filename="filename"
      @close="closeStatuDialog"
    >
    </status-info>
    <!---------------------------------------------------------------------------->
    <WHLanguageForm
      v-if="showBrandForm"
      :isUpdate="isUpdate"
      :close="closeModal"
      :DoesCreated="DoesCreated"
      :Brand="brand"
    ></WHLanguageForm>
    <!-----------------STATUS DIALOG, WHEN DOING STUFF WITH BRANDS---------------->
    <v-dialog persistent v-model="statusDialog" width="unset">
      <status-info
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="closeStatuDialog"
      ></status-info>
    </v-dialog>
    <v-dialog persistent v-model="showTranslation" width="1000px">
      <v-card v-if="missing">
        <v-card-title class="subtitle-1 grey accent" primary-title>
          <span class="text-h5"
            >Translate those words to this language : {{ name }}</span
          >
        </v-card-title>
        <v-card-text v-if="missing.hasMissing == false">
          <v-alert class="alert" color="#B9F6CA"
            >There is no words to translate</v-alert
          >
        </v-card-text>
        <v-card-text v-if="missing.hasMissing == true">
          <v-form ref="form" lazy-validation @input="formToggled">
            <v-expansion-panels
              class="container"
              v-if="missing.categories.length > 0"
            >
              <v-expansion-panel>
                <v-expansion-panel-header> Categories</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row v-for="(item, i) in missing.categories" :key="i">
                    <v-col>
                      <h4>{{ item.name }}</h4>
                    </v-col>
                    <v-col>
                      <v-text-field
                        color="accent"
                        :label="item.name"
                        v-model="item[Lang]"
                        type="text"
                        outlined
                        dense
                        clearable
                        :rules="[rules.required]"
                        @wheel="$event.target.blur()"
                      >
                      </v-text-field
                    ></v-col>
                  </v-row> </v-expansion-panel-content></v-expansion-panel
            ></v-expansion-panels>

            <v-expansion-panels
              class="container"
              v-if="missing.seasons.length > 0"
            >
              <v-expansion-panel>
                <v-expansion-panel-header> Seasons</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row v-for="(item, i) in missing.seasons" :key="i">
                    <v-col>
                      <h4>{{ item.name }}</h4>
                    </v-col>
                    <v-col>
                      <v-text-field
                        color="accent"
                        :label="item.name"
                        v-model="item[Lang]"
                        type="text"
                        outlined
                        dense
                        clearable
                        :rules="[rules.required]"
                        @wheel="$event.target.blur()"
                      >
                      </v-text-field
                    ></v-col>
                  </v-row> </v-expansion-panel-content></v-expansion-panel
            ></v-expansion-panels>

            <v-expansion-panels
              class="container"
              v-if="missing.colors.length > 0"
            >
              <v-expansion-panel>
                <v-expansion-panel-header> Colors</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row v-for="(item, i) in missing.colors" :key="i">
                    <v-col>
                      <h4>{{ item.name }}</h4>
                    </v-col>
                    <v-col>
                      <v-text-field
                        color="accent"
                        :label="item.name"
                        v-model="item[Lang]"
                        type="text"
                        outlined
                        dense
                        clearable
                        :rules="[rules.required]"
                        @wheel="$event.target.blur()"
                      >
                      </v-text-field
                    ></v-col>
                  </v-row> </v-expansion-panel-content></v-expansion-panel
            ></v-expansion-panels>

            <v-expansion-panels
              class="container"
              v-if="missing.genders.length > 0"
            >
              <v-expansion-panel>
                <v-expansion-panel-header> Genders</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row v-for="(item, i) in missing.genders" :key="i">
                    <v-col>
                      <h4>{{ item.name }}</h4>
                    </v-col>
                    <v-col>
                      <v-text-field
                        color="accent"
                        :label="item.name"
                        v-model="item[Lang]"
                        type="text"
                        outlined
                        dense
                        clearable
                        :rules="[rules.required]"
                        @wheel="$event.target.blur()"
                      >
                      </v-text-field
                    ></v-col>
                  </v-row> </v-expansion-panel-content></v-expansion-panel
            ></v-expansion-panels>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="closeModal" color="info"> Close </v-btn>
          <v-btn v-if="missing.hasMissing" color="success" @click="translate">
            Translate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---------------------------------------------------------------------------------->
  </v-container>
  <!------------------------------------------------------------------------------->
</template>

<script>
import axios from "axios";
import StatusInfo from "../organisms/StatusInfo";
import WHLanguageForm from "../modals/WHLanguage.vue";
export default {
  name: "WHLanguage",
  components: {
    StatusInfo,
    WHLanguageForm,
  },
  data: () => ({
    valid: true,
    search: "",
    showTranslation: false,
    dialogDelete: false,
    dialogDeleteRRP: false,
    currentLanguage: null,
    snackbar: false,
    snackbarSuccess: false,
    snackbarText: "",
    snackbarSuccessText: "",
    finalBrands: [],
    headers: [
      { text: "Title", value: "name" },
      { text: "code", value: "code" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    rules: {
      required: (value) => !!value || "Field is required.",
    },
    brands: [],
    selecetdBrand: "",
    editedItem: {},
    responseMessage: "",
    filename: "",
    failed: false,
    statusDialog: false,
    pending: false,

    showBrandForm: false,
    brand: undefined,
    formTitle: "",
    isUpdate: false,
    missing: [],
    Lang: null,
    name: null,
  }),
  mounted() {
    this.getData();
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  computed: {},
  methods: {
    async translateMissing(item) {
      this.pending = true;
      this.statusDialog = true;
      this.Lang = item.code;
      this.name = item.name;
      await axios
        .get("/api/missing-translation/" + item.code)
        .then((res) => {
          this.missing = res.data;
          this.pending = false;
          this.statusDialog = false;
          this.showTranslation = true;
        })
        .catch(() => {});
    },

    editBrand(item) {
      this.brand = item;
      this.isUpdate = true;
      this.formTitle = `Edit brand ${item.brandName}`;
      this.showBrandForm = true;
    },
    addNewBrand() {
      this.brand = {};
      this.formTitle = `Add brand`;
      this.showBrandForm = true;
    },
    closeBrandForm(changed) {
      this.showBrandForm = false;
      //if brands changed
      if (changed) {
        this.getData();
      }
    },
    closeModal() {
      this.isUpdate = false;
      this.showBrandForm = false;
      this.showTranslation = false;
    },
    DoesCreated() {
      this.getData();
    },
    async getData() {
      this.$store
        .dispatch("getWHLanguage")
        .then((result) => {
          console.log(result.data);
          this.brands = result.data;
          this.finalBrands = result.data;
        })
        .catch((error) => {
          console.log(error);
          switch (error.response.status) {
            case 400:
              this.filename = "empty.svg";
              this.failed = true;
              this.responseMessage =
                "Sorry, something went wrong, please contact TECH team!";
              break;
            case 401:
              //clear local storage, push to login
              localStorage.clear();
              this.$router.push("login");
              break;
            case 403:
              this.filename = "403_forbidden.svg";
              this.failed = true;
              this.responseMessage =
                "Sorry, you are forbidden to do this action!";
              break;
            case 500:
              this.filename = "server_down.svg";
              this.failed = true;
              this.responseMessage =
                "Internal server error, please contact TECH team!";
          }
        });
    },
    async translate() {
      console.log(this.missing);
      var valid = false;
      for (var i = 0; i < this.missing.categories.length; i++) {
        if (
          !this.missing.categories[i][this.Lang] ||
          this.missing.categories[i][this.Lang].length == 0
        ) {
          valid = true;
          break;
        }
      }
      for (var k = 0; k < this.missing.seasons.length; k++) {
        if (
          !this.missing.seasons[k][this.Lang] ||
          this.missing.seasons[k][this.Lang].length == 0
        ) {
          valid = true;
          break;
        }
      }
      for (var e = 0; e < this.missing.genders.length; e++) {
        if (
          !this.missing.genders[e][this.Lang] ||
          this.missing.genders[e][this.Lang].length == 0
        ) {
          valid = true;
          break;
        }
      }
      for (var j = 0; j < this.missing.colors.length; j++) {
        if (
          !this.missing.colors[j][this.Lang] ||
          this.missing.colors[j][this.Lang].length == 0
        ) {
          valid = true;
          break;
        }
      }
      if (valid) {
        this.snackbar = true;
        this.snackbarText = "Please fill up all the inputs !";
      } else {
        this.pending = true;
        this.statusDialog = true;
        await axios.post("/api/missing-translation", this.missing).then(() => {
          this.showTranslation = false;
          this.pending = false;
          this.statusDialog = true;
          this.responseMessage = "Translation created ! ";
          this.filename = "high_five.svg";
        });
      }
    },
    //CHECK IF ARRAYS ARE EQUAL
    checkArrays(array1, array2) {
      const arraysEqual = (a1, a2) =>
        a1.length === a2.length &&
        a1.every((o, idx) => objectsEqual(o, a2[idx]));

      const objectsEqual = (o1, o2) =>
        typeof o1 === "object" && Object.keys(o1).length > 0
          ? Object.keys(o1).length === Object.keys(o2).length &&
            Object.keys(o1).every((p) => objectsEqual(o1[p], o2[p]))
          : o1 === o2;
      return arraysEqual(array1, array2);
    },

    deleteItem(item) {
      this.editedIndex = this.finalBrands.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
      this.selecetdBrand = item.name;
    },

    deleteItemConfirm() {
      this.pending = true;
      this.statusDialog = true;
      this.dialogDelete = false;
      //deleting brand
      let brandName = this.editedItem.name;
      axios
        .delete("api/WHLanguage/" + this.editedItem.id)
        .then(() => {
          this.filename = "high_five.svg";
          this.pending = false;
          this.dialogDelete = false;
          this.responseMessage = "Success! Language " + brandName + " deleted!";
        })
        .catch((error) => {
          switch (error.response.status) {
            case 400:
              this.filename = "empty.svg";
              this.pending = false;
              this.responseMessage =
                "Sorry, something went wrong, please contact TECH team!";
              break;
            case 401:
              //clear local storage, push to login
              localStorage.clear();
              this.$router.push("login");
              break;
            case 403:
              this.filename = "403_forbidden.svg";
              this.pending = false;
              this.responseMessage =
                "Sorry, you are forbidden to do this action!";
              break;
            case 500:
              this.filename = "server_down.svg";
              this.pending = false;
              this.responseMessage =
                "Internal server error, please contact TECH team!";
          }
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.brandStories = [""];
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeStatuDialog() {
      this.getData();
      this.isUpdate = false;
      this.statusDialog = false;
    },
  },
};
</script>
<style>
.translate-btn {
  margin: 1em;
}
.translation-action {
  width: 1px !important;
  display: flex;
}
.container {
  margin-top: 25px;
}
.alert {
  margin-top: 25px;
}
</style>
